class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-recommendations-track]');
    this.url = this.dataset.url;
    this.embla = null;

    this.load();

    this._onCartUpdated = () => this.load();
    window.addEventListener('cart:updated', this._onCartUpdated);

    this.addEventListener('change', (e) => {
      if (e.target.matches('.cart-recommendation__form select')) {
        this.updateVariant(e.target.closest('[data-recommendation]'));
      }
    });

    this.addEventListener('click', (e) => {
      const add = e.target.closest('[data-recommendation-add]');
      if (add) this.add(add);
    });
  }

  disconnectedCallback() {
    window.removeEventListener('cart:updated', this._onCartUpdated);
    this.embla?.destroy();
  }

  async load() {
    if (!this.url || !this.track) return;
    try {
      const res = await fetch(this.url);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const next = doc.querySelector('[data-recommendations-track]');

      if (!next || !next.querySelector('[data-recommendation]')) {
        this.hidden = true;
        return;
      }

      this.track.innerHTML = next.innerHTML;
      this.hidden = false;
      this.track
        .querySelectorAll('[data-recommendation]')
        .forEach((card) => this.initCard(card));
      this.initCarousel();
    } catch (err) {
      console.error(err);
    }
  }

  initCarousel() {
    this.embla?.destroy();
    this.embla = EmblaCarousel(this.track, { loop: true, align: 'start' });

    const nav = this.querySelector('[data-recommendations-nav]');
    if (!nav) return;
    const [prev, next] = nav.children;
    prev.onclick = () => this.embla.scrollPrev();
    next.onclick = () => this.embla.scrollNext();
  }

  initCard(card) {
    card._variants = JSON.parse(
      card.querySelector('[data-recommendation-variants]').textContent,
    );
    card._selected = card._variants.find((v) => v.available) || card._variants[0];
    if (!card._selected) return;
    card._selected.options.forEach((opt, i) => {
      const select = card.querySelectorAll('select')[i];
      if (select) select.value = opt;
    });
  }

  updateVariant(card) {
    const form = card.querySelector('form');
    const selections = Array.from(new FormData(form).values());
    const variant = card._variants.find((v) =>
      v.options.every((o) => selections.includes(o)),
    );
    card._selected = variant;

    const btn = card.querySelector('[data-recommendation-add]');
    btn.disabled = !variant || !variant.available;
    if (!variant) return;

    const img = card.querySelector('img');
    if (img && variant.featured_image) {
      const src = `${variant.featured_image.src}&width=150&height=150`;
      img.src = src;
      img.srcset = `${src} 150w`;
    }

    const price = card.querySelector('[data-recommendation-price]');
    if (price) price.textContent = this.formatMoney(variant.price);
  }

  async add(btn) {
    const card = btn.closest('[data-recommendation]');
    const variant = card._selected;
    if (!variant || !variant.available) return;

    const label = btn.querySelector('span') || btn;
    const original = label.textContent;
    label.textContent = 'Adding…';
    btn.disabled = true;

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error(`Add to cart failed: ${res.status}`);
      window.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.error(err);
    } finally {
      label.textContent = original;
      btn.disabled = false;
    }
  }

  formatMoney(cents) {
    const locale = window.Shopify.locale || 'en-GB';
    const currency = (window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }
}

customElements.define('cart-recommendations', CartRecommendations);
